import ContratConfig from '../models/config.model'

export default {
  editConfig: ({ PUT }, model) =>
    new Promise((resolve, reject) => {
      if (!(model instanceof ContratConfig)) {
        return reject(
          new Error(
            `Erreur paramètre : ${ContratConfig.constructor.name} attendu mais reçu "${model.constructor.name}"`
          )
        )
      } else if (model.isNew()) {
        return reject(
          new Error(
            `Erreur paramètre : ${ContratConfig.constructor.name} is new`
          )
        )
      }

      return PUT(`production/contrats/configs/${model.getAnnee()}`, model)
        .then((reponse) => {
          const data = reponse.data
          if (reponse.status === 200 && data.id) {
            const model = new ContratConfig(data)
            resolve(model)
          } else {
            reject(reponse.status)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
}
